import { ReactNode } from 'react';

type QuickInfoProps = {
    label: string;
    icon: ReactNode;
};

function QuickInfo({ label, icon }: QuickInfoProps): JSX.Element {
    return (
        <>
            <label className="text-gray-500 text-sm flex items-center">
                <span className="h-5 w-5 inline">{icon}</span>
                {label}
            </label>
        </>
    );
}

export default QuickInfo;
